import PropTypes from "prop-types";
import React, { Component } from "react";
import Select from "@material-ui/core/Select";
import { getDefaultLocale } from "../utils/i18n";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { localeSetLanguage } from "../actions";
import { connect } from "react-redux";
import { Trans } from "@lingui/macro";
import { goToBeginning } from "../utils/scenario-manager";

class LocaleSwitcher_old extends Component {
  onChangeLocale = event => {
    event.preventDefault();
    this.props.setLanguage(event.target.value);
    this.props.goToBeginning();
  };

  render() {
    return (
      <FormControl variant="outlined">
        <div className="wrap-select">
          <Select
            value={this.props.language}
            className="select-lang"
            onChange={this.onChangeLocale}
            inputProps={{
              name: "locale"
            }}
          >
            <MenuItem value="fr">
              <div className="wrap-content-lang">
                <img
                  width="20"
                  src="images/fr.svg"
                  alt={<Trans id="W_LANG_FR" />}
                />{" "}
                <Trans id="W_LANG_FR" />
              </div>
            </MenuItem>
            <MenuItem value="en">
              <div className="wrap-content-lang">
                <img
                  width="20"
                  src="images/en.svg"
                  alt={<Trans id="W_LANG_EN" />}
                />{" "}
                <Trans id="W_LANG_EN" />
              </div>
            </MenuItem>
            <MenuItem value="it">
              <div className="wrap-content-lang">
                <img
                  width="20"
                  src="images/it.svg"
                  alt={<Trans id="W_LANG_IT" />}
                />{" "}
                <Trans id="W_LANG_IT" />
              </div>
            </MenuItem>
            <MenuItem value="de">
              <div className="wrap-content-lang">
                <img
                  width="20"
                  src="images/de.svg"
                  alt={<Trans id="W_LANG_DE" />}
                />{" "}
                <Trans id="W_LANG_DE" />
              </div>
            </MenuItem>
            <MenuItem value="es">
              <div className="wrap-content-lang">
                <img
                  width="20"
                  src="images/es.svg"
                  alt={<Trans id="W_LANG_ES" />}
                />{" "}
                <Trans id="W_LANG_ES" />
              </div>
            </MenuItem>
          </Select>
        </div>
      </FormControl>
    );
  }
}

LocaleSwitcher_old.propTypes = {
  goToBeginning: PropTypes.func,
  language: PropTypes.any,
  setLanguage: PropTypes.func
};

const mapStateToProps = state => ({
  language: state.locale.language || getDefaultLocale()
});

const mapDispatchToProps = dispatch => ({
  setLanguage: language => dispatch(localeSetLanguage(language)),
  goToBeginning: () => dispatch(goToBeginning())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocaleSwitcher_old);
